import { Locations } from '../types/Locations';

// Define the airport interface
export interface Airport {
  id: Locations;
  name: string;
  code: string;
  coordinates: [number, number];
  color: string;
}

// New Zealand airports
export const NZ_AIRPORTS_DATA: Airport[] = [
  {
    id: Locations.NZAA, 
    name: "Auckland",
    code: "NZAA", 
    coordinates: [174.7832, -37.0082], 
    color: '#757575' 
  },
  { 
    id: Locations.NZCH, 
    name: "Christchurch",
    code: "NZCH", 
    coordinates: [172.5369, -43.4864], 
    color: '#757575'
  },
  { 
    id: Locations.NZDN, 
    name: "Dunedin",
    code: "NZDN", 
    coordinates: [170.1975, -45.9219], 
    color: '#757575' 
  },
  { 
    id: Locations.NZHN, 
    name: "Hamilton",
    code: "NZHN", 
    coordinates: [175.3347, -37.8666], 
    color: '#757575' 
  },
  { 
    id: Locations.NZWN, 
    name: "Wellington",
    code: "NZWN", 
    coordinates: [174.8093, -41.3276], 
    color: '#757575' 
  },
  // Disabled NZ airports — not currently enabled in backend permissions
  // {
  //   id: Locations.NZQN,
  //   name: "Queenstown",
  //   code: "NZQN",
  //   coordinates: [168.7392, -45.0211],
  //   color: '#757575'
  // },
  // {
  //   id: Locations.NZNS,
  //   name: "Nelson",
  //   code: "NZNS",
  //   coordinates: [173.2213, -41.2983],
  //   color: '#757575'
  // },
  // {
  //   id: Locations.NZNP,
  //   name: "New Plymouth",
  //   code: "NZNP",
  //   coordinates: [174.1792, -39.0086],
  //   color: '#757575'
  // },
  {
    id: Locations.NZPM,
    name: "Palmerston North",
    code: "NZPM",
    coordinates: [175.6169, -40.3206],
    color: '#757575'
  },
  // {
  //   id: Locations.NZTG,
  //   name: "Tauranga",
  //   code: "NZTG",
  //   coordinates: [176.1957, -37.6728],
  //   color: '#757575'
  // },
  // {
  //   id: Locations.NZRO,
  //   name: "Rotorua",
  //   code: "NZRO",
  //   coordinates: [176.3170, -38.1091],
  //   color: '#757575'
  // },
  // {
  //   id: Locations.NZGS,
  //   name: "Gisborne",
  //   code: "NZGS",
  //   coordinates: [177.9784, -38.6633],
  //   color: '#757575'
  // },
  // {
  //   id: Locations.NZNR,
  //   name: "Napier",
  //   code: "NZNR",
  //   coordinates: [176.8700, -39.4658],
  //   color: '#757575'
  // },
  // {
  //   id: Locations.NZWR,
  //   name: "Whangarei",
  //   code: "NZWR",
  //   coordinates: [174.3650, -35.7683],
  //   color: '#757575'
  // },
  // {
  //   id: Locations.NZHK,
  //   name: "Hokitika",
  //   code: "NZHK",
  //   coordinates: [170.9853, -42.7136],
  //   color: '#757575'
  // },
  // {
  //   id: Locations.NZWB,
  //   name: "Blenheim",
  //   code: "NZWB",
  //   coordinates: [173.8703, -41.5183],
  //   color: '#757575'
  // },
  // {
  //   id: Locations.NZTU,
  //   name: "Timaru",
  //   code: "NZTU",
  //   coordinates: [171.2253, -44.3028],
  //   color: '#757575'
  // },
  // {
  //   id: Locations.NZNV,
  //   name: "Invercargill",
  //   code: "NZNV",
  //   coordinates: [168.3131, -46.4125],
  //   color: '#757575'
  // },
  // {
  //   id: Locations.NZAP,
  //   name: "Taupo",
  //   code: "NZAP",
  //   coordinates: [176.0842, -38.7397],
  //   color: '#757575'
  // },
  // {
  //   id: Locations.NZKK,
  //   name: "Kerikeri",
  //   code: "NZKK",
  //   coordinates: [173.9119, -35.2628],
  //   color: '#757575'
  // },
  // {
  //   id: Locations.NZOH,
  //   name: "Ohakea",
  //   code: "NZOH",
  //   coordinates: [175.3878, -40.2061],
  //   color: '#757575'
  // }
];

// United Kingdom airports
export const UK_AIRPORTS_DATA: Airport[] = [
  { id: Locations.EGLC, name: "London City", code: "EGLC", coordinates: [0.055278, 51.505299], color: '#757575' },
  { id: Locations.EGKK, name: "London Gatwick", code: "EGKK", coordinates: [-0.192089, 51.148771], color: '#757575' },
  { id: Locations.EGMC, name: "London Southend", code: "EGMC", coordinates: [0.693627, 51.570562], color: '#757575' },
  { id: Locations.EGLL, name: "London Heathrow", code: "EGLL", coordinates: [-0.461941, 51.4706], color: '#757575' },
  { id: Locations.EGSS, name: "London Stansted", code: "EGSS", coordinates: [0.235, 51.884998], color: '#757575' },
  { id: Locations.EGGW, name: "London Luton", code: "EGGW", coordinates: [-0.368333, 51.874699], color: '#757575' },
  { id: Locations.EGTE, name: "Exeter", code: "EGTE", coordinates: [-3.413984, 50.734261], color: '#757575' },
  { id: Locations.EGBB, name: "Birmingham", code: "EGBB", coordinates: [-1.74803, 52.453899], color: '#757575' },
  { id: Locations.EGFF, name: "Cardiff", code: "EGFF", coordinates: [-3.34333, 51.396702], color: '#757575' },
  { id: Locations.EGAC, name: "Belfast City", code: "EGAC", coordinates: [-5.8725, 54.618099], color: '#757575' },
  { id: Locations.EGPK, name: "Glasgow Prestwick", code: "EGPK", coordinates: [-4.587019, 55.502003], color: '#757575' },
  { id: Locations.EGPH, name: "Edinburgh", code: "EGPH", coordinates: [-3.372288, 55.950145], color: '#757575' },
  { id: Locations.EGCC, name: "Manchester", code: "EGCC", coordinates: [-2.279521, 53.349375], color: '#757575' },
  // { id: Locations.EGGD, name: "Bristol", code: "EGGD", coordinates: [-2.71909, 51.382702], color: '#757575' },
  // { id: Locations.EGNT, name: "Newcastle", code: "EGNT", coordinates: [-1.689577, 55.037958], color: '#757575' },
  // { id: Locations.EGNX, name: "East Midlands", code: "EGNX", coordinates: [-1.32806, 52.8311], color: '#757575' },
  // { id: Locations.EGPD, name: "Aberdeen", code: "EGPD", coordinates: [-2.19778, 57.2019], color: '#757575' },
  // { id: Locations.EGJJ, name: "Jersey", code: "EGJJ", coordinates: [-2.19551, 49.207901], color: '#757575' },
  // { id: Locations.EGPE, name: "Inverness", code: "EGPE", coordinates: [-4.047500133514404, 57.54249954223633], color: '#757575' },
  // { id: Locations.EGJB, name: "Guernsey", code: "EGJB", coordinates: [-2.60197, 49.435001], color: '#757575' },
  // { id: Locations.EGHH, name: "Bournemouth", code: "EGHH", coordinates: [-1.839576, 50.780483], color: '#757575' },
  // { id: Locations.EGSH, name: "Norwich", code: "EGSH", coordinates: [1.28278, 52.6758], color: '#757575' },
  // { id: Locations.EGHQ, name: "Newquay Cornwall", code: "EGHQ", coordinates: [-4.99541, 50.440601], color: '#757575' },
  // { id: Locations.EGNS, name: "Isle of Man", code: "EGNS", coordinates: [-4.62389, 54.083302], color: '#757575' },
  // { id: Locations.EGNV, name: "Durham Tees Valley", code: "EGNV", coordinates: [-1.42941, 54.509201], color: '#757575' },
  // { id: Locations.EGCN, name: "Doncaster Sheffield", code: "EGCN", coordinates: [-1.01065, 53.480759], color: '#757575' },
  // { id: Locations.EGPO, name: "Stornoway", code: "EGPO", coordinates: [-6.33111, 58.215599], color: '#757575' },
  // { id: Locations.EGPB, name: "Sumburgh", code: "EGPB", coordinates: [-1.29556, 59.878899], color: '#757575' },
  // { id: Locations.EGPA, name: "Kirkwall", code: "EGPA", coordinates: [-2.9049999713897705, 58.957801818847656], color: '#757575' },
  // { id: Locations.EGSC, name: "Cambridge", code: "EGSC", coordinates: [0.175, 52.205002], color: '#757575' },
  // { id: Locations.EGPN, name: "Dundee", code: "EGPN", coordinates: [-3.025830030441284, 56.45249938964844], color: '#757575' },
  // { id: Locations.EGPL, name: "Benbecula", code: "EGPL", coordinates: [-7.3627800941467285, 57.48109817504883], color: '#757575' },
  // { id: Locations.EGPI, name: "Islay", code: "EGPI", coordinates: [-6.257525, 55.682708], color: '#757575' },
  // { id: Locations.EGPU, name: "Tiree", code: "EGPU", coordinates: [-6.869170188903809, 56.49919891357422], color: '#757575' },
  // { id: Locations.EGPR, name: "Barra", code: "EGPR", coordinates: [-7.44306, 57.0228], color: '#757575' },
  // { id: Locations.EGEC, name: "Campbeltown", code: "EGEC", coordinates: [-5.686389923095703, 55.437198638916016], color: '#757575' },
  // { id: Locations.EGHC, name: "Land's End", code: "EGHC", coordinates: [-5.67056, 50.102798], color: '#757575' },
  // { id: Locations.EGHE, name: "Scilly Isles", code: "EGHE", coordinates: [-6.291894, 49.913375], color: '#757575' },
  // { id: Locations.EGNH, name: "Blackpool", code: "EGNH", coordinates: [-3.02861, 53.771702], color: '#757575' },
  // { id: Locations.EGAE, name: "City of Derry", code: "EGAE", coordinates: [-7.161109924316406, 55.04280090332031], color: '#757575' }
];

// Disabled UK airports - not currently enabled in backend permissions
export const SIDELINED_UK_AIRPORTS_DATA: Airport[] = [
  { id: Locations.EGHI, name: "Southampton", code: "EGHI", coordinates: [-1.3568, 50.950298], color: '#757575' },
  { id: Locations.EGPF, name: "Glasgow", code: "EGPF", coordinates: [-4.43306, 55.871899], color: '#757575' },
  { id: Locations.EGAA, name: "Belfast International", code: "EGAA", coordinates: [-6.2158298492399995, 54.6575012207], color: '#757575' },
  { id: Locations.EGGP, name: "Liverpool John Lennon", code: "EGGP", coordinates: [-2.84972, 53.333599], color: '#757575' },
  { id: Locations.EGNM, name: "Leeds Bradford", code: "EGNM", coordinates: [-1.66057, 53.865898], color: '#757575' },
];

// European Union airports
export const EU_AIRPORTS_DATA: Airport[] = [
  { id: Locations.EIDW, name: "Dublin", code: "EIDW", coordinates: [-6.270075, 53.421333], color: '#757575' },
  { id: Locations.EHAM, name: "Amsterdam Schiphol", code: "EHAM", coordinates: [4.763889, 52.308056], color: '#757575' },
];

// All airport data combined (including sidelined airports for pypervision users)
export const ALL_AIRPORTS_DATA: Airport[] = [
  ...NZ_AIRPORTS_DATA,
  ...UK_AIRPORTS_DATA,
  ...SIDELINED_UK_AIRPORTS_DATA,
  ...EU_AIRPORTS_DATA
];

// All NZ locations that can have forecast data
export const ALL_NZ_LOCATIONS = [
  Locations.NZAA, // Auckland
  Locations.NZCH, // Christchurch
  Locations.NZDN, // Dunedin
  Locations.NZHN, // Hamilton
  Locations.NZWN, // Wellington
  Locations.NZQN, // Queenstown
  Locations.NZNS, // Nelson
  Locations.NZNP, // New Plymouth
  Locations.NZPM, // Palmerston North
  Locations.NZTG, // Tauranga
  Locations.NZRO, // Rotorua
  Locations.NZGS, // Gisborne
  Locations.NZNR, // Napier
  Locations.NZWR, // Whangarei
  Locations.NZHK, // Hokitika
  Locations.NZWB, // Blenheim
  Locations.NZTU, // Timaru
  Locations.NZNV, // Invercargill
  Locations.NZAP, // Taupo
  Locations.NZKK, // Kerikeri
  Locations.NZOH  // Ohakea
];

// All UK locations that can have forecast data
export const ALL_UK_LOCATIONS = [
  Locations.EGLC,
  Locations.EGKK,
  Locations.EGMC,
  Locations.EGLL,
  Locations.EGSS,
  Locations.EGGW,
  Locations.EGTE,
  Locations.EGBB,
  Locations.EGFF,
  Locations.EGAC,
  Locations.EGPK,
  Locations.EGPH,
  Locations.EGCC,
  // Locations.EGGD,
  // Locations.EGPF,
  // Locations.EGAA,
  // Locations.EGNT,
  // Locations.EGNX,
  // Locations.EGNM,
  // Locations.EGGP,
  // Locations.EGPD,
  // Locations.EGJJ,
  // Locations.EGPE,
  // Locations.EGJB,
  // Locations.EGHH,
  // Locations.EGSH,
  // Locations.EGHQ,
  // Locations.EGNS,
  // Locations.EGNV,
  // Locations.EGCN,
  // Locations.EGPO,
  // Locations.EGPB,
  // Locations.EGPA,
  // Locations.EGSC,
  // Locations.EGPN,
  // Locations.EGPL,
  // Locations.EGPI,
  // Locations.EGPU,
  // Locations.EGPR,
  // Locations.EGEC,
  // Locations.EGHC,
  // Locations.EGHE,
  // Locations.EGNH,
  // Locations.EGAE,
];

// Disabled UK locations - not currently enabled in backend permissions
export const SIDELINED_UK_LOCATIONS = [
  Locations.EGHI, // Southampton
  Locations.EGPF, // Glasgow
  Locations.EGAA, // Belfast International
  Locations.EGGP, // Liverpool John Lennon
  Locations.EGNM, // Leeds Bradford
];

// All EU locations that can have forecast data
export const ALL_EU_LOCATIONS = [
  Locations.EIDW, // Dublin
  Locations.EHAM, // Amsterdam Schiphol
];

// Combined UK & EU locations for shared timeline rendering
export const ALL_UK_EU_LOCATIONS = [
  ...ALL_UK_LOCATIONS,
  ...ALL_EU_LOCATIONS
];

// All locations (NZ + UK + EU) that can have forecast data
export const ALL_LOCATIONS = [
  ...ALL_NZ_LOCATIONS,
  ...ALL_UK_LOCATIONS,
  ...ALL_EU_LOCATIONS
];

// Default locations to show data for (Christchurch and Hamilton)
export const DEFAULT_DATA_LOCATIONS = [
  Locations.NZCH, // Christchurch
  Locations.NZHN  // Hamilton
];